import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Aurora from '../components/fx/Aurora';
import Particles from '../components/fx/Particles';
import Magnetic from '../components/fx/Magnetic';
import Button from '../components/ui/Button';
import { LogoMark } from '../components/ui/Logo';

export default function NotFound() {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden px-4">
      <Aurora />
      <Particles className="opacity-60" />
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative z-10 text-center"
      >
        <motion.div
          animate={{ y: [0, -10, 0] }}
          transition={{ duration: 5, repeat: Infinity, ease: 'easeInOut' }}
        >
          <LogoMark className="mx-auto h-12 w-12" />
        </motion.div>
        <h1 className="mt-6 font-display text-7xl font-semibold tracking-tight text-flow">404</h1>
        <p className="mt-3 text-lg text-content-muted">This page drifted off into the aether.</p>
        <div className="mt-8 flex justify-center gap-3">
          <Magnetic strength={0.4}>
            <Link to="/">
              <Button variant="secondary">Back home</Button>
            </Link>
          </Magnetic>
          <Magnetic strength={0.5}>
            <Link to="/app">
              <Button>Go to studio</Button>
            </Link>
          </Magnetic>
        </div>
      </motion.div>
    </div>
  );
}
